/**
 * PLP Stock Badge — updates product card stock badges when state changes.
 * Reads data-stock-by-state attribute (JSON) from .prod-card elements.
 */
import { GlobalState } from '../../global-state/global-state';
import { STATE_EVENTS } from '../../utils/state-events';

// Expose GlobalState on window for bc-sf-filter.js (vendor, not in webpack bundle)
window.GlobalState = GlobalState;

function updateBadge(card) {
  const badgeEl = card.querySelector('.prod-card__stock-badge');
  if (!badgeEl) return;

  const stockJSON = card.getAttribute('data-stock-by-state');
  if (!stockJSON) {
    badgeEl.innerHTML = '';
    return;
  }

  let stockData;
  try {
    stockData = JSON.parse(stockJSON);
  } catch (e) {
    badgeEl.innerHTML = '';
    return;
  }

  const state = GlobalState.getEffectiveState();
  if (!state) {
    badgeEl.innerHTML = '<span class="prod-card__stock-badge prod-card__stock-badge--no-state">Select state for availability</span>';
    return;
  }

  const available = !!stockData[state];
  if (available) {
    badgeEl.innerHTML = '<span class="prod-card__stock-badge prod-card__stock-badge--in-stock">In Stock</span>';
  } else {
    badgeEl.innerHTML = '<span class="prod-card__stock-badge prod-card__stock-badge--oos">Out of Stock</span>';
  }
}

function updateAllBadges() {
  document.querySelectorAll('.prod-card[data-stock-by-state]').forEach(updateBadge);
}

window.updatePlpStockBadges = updateAllBadges;

export default function PlpStockBadge() {
  window.addEventListener(STATE_EVENTS.SELECTED, updateAllBadges);
  window.addEventListener(STATE_EVENTS.CLEARED, updateAllBadges);
  window.addEventListener(STATE_EVENTS.DETECTED, updateAllBadges);
}
